import React from "react";
import GLOBAL from "../../global";
import IconCloseButton from "../shared/IconCloseButton";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";

const MobileAppSuggestions = () => {
    const { androidAppLink: androidPlayStoreLink, iosApplink: iosAppStorelink, mobileAppSuggestionDescription, androidPlayStoreImage, iosAppStoreImage } = useTenantFeatures();

    return (
        <div className="mobile-app-suggestion">
            <div>
                <p className="heading">Download App</p>
                <p className="subheading">{mobileAppSuggestionDescription}</p>
            </div>

            <div className="mobile-app-suggestion-store-container">
                {/* App Store Button */}
                <a href={iosAppStorelink} target="_blank" rel="noopener noreferrer" className="store-download-button">
                    <img className="apple" src={iosAppStoreImage} alt="App Store" />
                </a>

                {/* Google Play Button */}
                <a href={androidPlayStoreLink} target="_blank" rel="noopener noreferrer" className="store-download-button">
                    <img className="playstore" src={androidPlayStoreImage} alt="Google Play" />
                </a>

                {/*<IconCloseButton />*/}
            </div>
        </div>
    )
};

export default MobileAppSuggestions;
